<template>
  <div class="left-navigation body-menu">
    <div class="menu-position">
      <div v-if="onType === 'product'" class="menu-header" :class="{ en: $store.state.dynamic.lang === 'en' }">{{
        $t('product.productCenter') }}</div>
      <ul class="menu-ul">
        <li :class="{ active: item.id === onId }" class="menu-li" v-for="item in menuList" :key="item.id"
          @click="goMenu(item)">{{ item.text }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { navigationList } from "../../../config/dictionary";
export default {
  name: "ProductLeftNavigation",
  props: {
    currentMenuId: {
      type: String,
      default: ""
    },
    rightClass: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      menuList: [],
      onType: "",
      onId: "",
      keepH: 0,
      wheelName: navigator.userAgent.toUpperCase().includes("Firefox")
        ? "DOMMouseScroll"
        : "mousewheel"
    };
  },
  methods: {
    goMenu(item) {
      this.$router.push({
        path: item.href
      });
    },
    listenFunc(e) {
      const _this = this;
      const parentEl = document.querySelector(".body-menu");
      const positionEl = document.querySelector(".menu-position");
      const rightContentEl = document.querySelector(`.${_this.rightClass}`);
      let timer = null;
      if (timer) clearTimeout(timer);
      e = e || window.event;
      timer = setTimeout(() => {
        const rectTop = parentEl.getBoundingClientRect().top;
        _this.keepH = _this.keepH || positionEl.getBoundingClientRect().height;
        positionEl.style.opacity = 0;
        if (rectTop < 0) {
          positionEl.style.top = -rectTop + 50 + "px";
          setTimeout(() => {
            const rightRect = rightContentEl.getBoundingClientRect();
            positionEl.style.display =
              rightRect.top + rightRect.height < _this.keepH ? "none" : "block";
            positionEl.style.opacity = 1;
          }, 10);
        } else {
          positionEl.style.top = 0;
          positionEl.style.opacity = 1;
        }
        clearTimeout(timer);
      }, 200);
    }
  },
  mounted() {
    console.log(this.$store);
    const idArr = this.currentMenuId.split("/");
    this.menuList = navigationList.find(item => {
      return item.id.toLowerCase() === idArr[0];
    }).children;
    this.onType = idArr[0];
    this.onId = idArr[1];
    // if (!this.rightClass) return;
    // document.addEventListener(this.wheelName, this.listenFunc);
  },
  destroyed() {
    // document.removeEventListener(this.wheelName, this.listenFunc);
  }
};
</script>

<style lang="less" scoped>
/***左侧导航样式*/
.left-navigation.body-menu {
  margin-top: 50px;
  width: 272px;
  height: 348px;
  flex-shrink: 0;
  position: relative;


  .menu-position {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    .menu-header {
      height: 80px;
      line-height: 80px;
      text-align: center;
      width: 100%;
      background: #e2211c;
      font-size: 32px;
      font-family: PingFang;
      font-weight: 500;
      color: #ffffff;

      &.en {
        font-size: 26px;
      }
    }

    .menu-li {
      height: 52px;
      line-height: 52px;
      text-align: center;
      background-color: rgba(30, 30, 30, 0.7);
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 2px;
      cursor: pointer;

      &:last-child {
        margin-bottom: 0;
      }

      &.active {
        color: #e2211c;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/ProductLeftNavigation.vue